import { type FilterItem } from 'widgets/FilterEditor/model'

export const MultiInboxesKeys = new Set(['broadcasts.number_id', 'workflows.number_id'])

export const isMultiInboxesWidget = (filterItem: FilterItem) => MultiInboxesKeys.has(filterItem.key)
